import styled from 'styled-components'
import { Theme } from '../../Theme';


const  Content = styled.div`

    margin-top: 0;

    .HeroSection {
        width: 100%;
        padding: 60px 20px 80px 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #f8f9fa;
        color: ${Theme.FIRST_COLOR};
        text-align: center;
        border-bottom: 1px solid #eee;

        h1 {
            font-size: 42px;
            margin-bottom: 10px;
            font-family: ${Theme.THIRD_FONT};
            letter-spacing: 1px;
            color: ${Theme.FIRST_COLOR};
        }

        p {
            font-size: 18px;
            opacity: 0.8;
            max-width: 600px;
            font-family: ${Theme.FIRST_FONT};
            color: ${Theme.FIRST_COLOR};
        }
    }

    .SearchArea {
        width: 100%;
        padding: 20px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: -35px; /* Sobe a barra para sobrepor o Hero */
    }

    .SearchContainer {
        width: 50%;
        display: flex;
        gap: 10px;
        background-color: white;
        padding: 8px;
        border: none;
        border-radius: 50px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.15);

        input {
            flex: 1;
            border: none;
            padding: 12px 25px;
            font-size: 16px;
            border-radius: 50px;
            outline: none;
            font-family: ${Theme.FIRST_FONT};
            background: white;
        }

        button {
            background-color: ${Theme.SECOND_COLOR};
            color: ${Theme.FIRST_COLOR};
            border: none;
            padding: 12px 35px;
            font-size: 15px;
            font-weight: 800;
            border-radius: 50px;
            cursor: pointer;
            transition: all 0.3s ease;
            font-family: ${Theme.FIRST_FONT};
            text-transform: uppercase;

            &:hover {
                filter: brightness(1.1);
                transform: scale(1.02);
                box-shadow: 0 5px 15px rgba(214, 218, 0, 0.4);
            }
        }
    }

    .NavigationTabs {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 40px 0;
        gap: 30px;

        .TabLink {
            font-family: ${Theme.FIRST_FONT};
            font-size: 16px;
            font-weight: 700;
            color: ${Theme.FIRST_COLOR};
            cursor: pointer;
            padding: 10px 20px;
            border-radius: 12px;
            transition: all 0.3s ease;
            border: 2px solid transparent;
            text-transform: uppercase;
            letter-spacing: 1px;

            &:hover {
                background: rgba(38, 85, 121, 0.05);
                color: ${Theme.SECOND_COLOR};
            }

            &.active {
                background: ${Theme.FIRST_COLOR};
                color: white;
            }
        }

        .Separator {
            width: 2px;
            height: 20px;
            background: #ddd;
        }
    }

    @media (max-width: 768px) {
        .HeroSection {
            padding: 40px 20px;
            h1 { font-size: 32px; }
            p { font-size: 16px; }
        }

        .SearchContainer {
            width: 90%;
            button {
                padding: 12px 20px;
                font-size: 13px;
            }
        }

        .NavigationTabs {
            gap: 15px;
            .TabLink {
                font-size: 14px;
                padding: 8px 15px;
            }
        }
    }

    .AllCourses {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 30px;
        padding: 40px 5%;
        background-color: #fafafa;
    }

    .FilterContainer {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
        border: 1px solid ${Theme.SECOND_COLOR};
        padding: 10px 25px;
        border-radius: 50px;
        font-size: 16px;
        font-weight: bold;
        color: ${Theme.FIRST_COLOR};
        margin-bottom: 30px;
        box-shadow: 0 4px 10px rgba(0,0,0,0.05);
        max-width: fit-content;
        margin-left: auto;
        margin-right: auto;
    }

    .ClearFilterButton {
        background: ${Theme.FIRST_COLOR};
        color: white;
        border: none;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        font-size: 14px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
        margin-left: 15px;
        padding: 0;

        &:hover {
            background: #cc3300;
            transform: rotate(90deg);
        }
    }

    @media (max-width: 900px) {
        .AllCourses > * {
            flex-basis: 48%;
            max-width: 48%;
        }
    }

    @media (max-width: 600px) {
        .AllCourses > * {
            flex-basis: 100%;
            max-width: 100%;
        }
    }
`;

export const Styled = {
    Content
}